module.exports = __webpack_public_path__ + "static/img/docx.95bbe148.png";